export const ApiLink = {
    API_URL: process.env.REACT_APP_API_URL_PROD,
    PHOTO_URL: process.env.REACT_APP_PHOTO_URL_PROD
};
